import React, { useState } from "react";
import FullScreenLoader from "../../components/FullScreenLoader";

function StatusRegistrationModal({
  selectedRowData,
  onClose,
  refreshOnSubmitSuccess,
}) {
  console.log(selectedRowData);

  const [isLoading, setIsLoading] = useState(false);

  const statusFields = [
    { label: "Parent Submitted", value: selectedRowData.isSubmit },
    {
      label: "Communicated to Guardian",
      value: selectedRowData.isCommunicatedToGuardian,
    },
    {
      label: "Interview Scheduled",
      value: selectedRowData.isInterviewScheduled,
    },
    { label: "Interview Taken", value: selectedRowData.isInterviewTaken },
    { label: "Accepted", value: selectedRowData.isAccepted },
    { label: "Assessment Added", value: selectedRowData.isAssessmentAdded },
    { label: "Center Submitted", value: selectedRowData.isCenterSubmit },
    { label: "Account Approved", value: selectedRowData.isAccountApproved },
    { label: "CEO Approved", value: selectedRowData.isCEOApproved },
    {
      label: "Account Adm Challan Verified",
      value: selectedRowData.isAccountAdmChallanVerified,
    },
    {
      label: "Account Reg Challan Verified",
      value: selectedRowData.isAccountRegChallanVerified,
    },
  ];

  return (
    <>
      {isLoading && <FullScreenLoader />}
      <div
        className="modal fade show"
        tabIndex="-1"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-sm">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="mb-0">Registration Status</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body fs-9">
              <div className="row">
                {statusFields.map(({ label, value }, index) => (
                  <div className="col-md-12 mb-2" key={index}>
                    <div className="d-flex justify-content-between align-items-center">
                      <span>
                        {index + 1}. <span>{label}</span>
                      </span>
                      <span>
                        {value ? (
                          <i className="fa fa-check text-success"></i>
                        ) : (
                          <i className="fa fa-times text-danger"></i>
                        )}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
}

export default StatusRegistrationModal;
